import React from "react";

interface MercosulPlateProps {
  value: string;
  onChange: (value: string) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
}

export const MercosulPlate: React.FC<MercosulPlateProps> = ({
  value,
  onChange,
  onKeyDown,
  placeholder = "ABC-1D34",
  className = "",
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value.toUpperCase().replace(/[^A-Z0-9-]/g, "");

    // Remove existing dashes to work with clean value
    const cleanValue = inputValue.replace(/-/g, "");

    // Apply formatting with dashes
    let formattedValue = "";

    if (cleanValue.length <= 3) {
      formattedValue = cleanValue;
    } else if (cleanValue.length <= 7) {
      // Old format: ABC1234 -> ABC-1234 (dash after 3rd character)
      formattedValue = cleanValue.slice(0, 3) + "-" + cleanValue.slice(3);
    } else {
      // Limit to 7 characters clean (will become 8 with dash)
      const limitedClean = cleanValue.slice(0, 7);
      formattedValue = limitedClean.slice(0, 3) + "-" + limitedClean.slice(3);
    }

    // Send formatted data with dash to backend
    onChange(formattedValue);
  };

  return (
    <div className={`relative w-full max-w-[280px] ${className}`}>
      <div className="bg-white dark:bg-white border-[3px] sm:border-4 border-zinc-900 dark:border-slate-200 rounded-lg shadow-lg dark:shadow-xl overflow-hidden aspect-[2/1] flex flex-col">
        <div className="bg-blue-600 text-white text-center py-0.5 sm:py-1 relative shrink-0">
          <div className="text-[10px] sm:text-sm font-bold tracking-wider">BRASIL</div>
          <div className="absolute right-2 top-0.5 sm:top-1 text-xs sm:text-base">🇧🇷</div>
        </div>

        <div className="relative flex flex-1 items-center justify-center min-h-0">
          <div className="absolute bottom-1.5 left-2 text-[10px] sm:text-xs font-bold text-black">
            BR
          </div>

          <input
            type="text"
            value={value}
            onChange={handleInputChange}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            maxLength={8}
            className="w-full h-full text-center text-2xl sm:text-4xl font-bold text-black placeholder:text-zinc-400 bg-transparent border-none outline-none font-mono px-6"
            style={{
              letterSpacing: "0.16em",
              textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
            }}
          />
        </div>
      </div>
    </div>
  );
};

